export const genericFormSlugs = [
  "enquiry-form",
  "Application Form",
  "thank-you-for-your-payment"
];

export const appFormSlug = [
  "application-form",
  "thank-you-for-your-application",
  "thank-you-for-your-complete-application",
  "group-application-form",
  "secure-your-spot",
  "enquiry-form",
  "group-application",
  "opendayssign-up",
  "thank-you-for-your-application/enrol",
  "enrol",
  "outreach-form",
  "pay-online"
];

export const templateList = [
  "volunteer page",
  "focus page",
  "location page",
  "extra-type page",
  "internship-abroad page",
  "text page",
  "parent info"
];

export const siteSwitcherEnabledPageList = [
  "/",
  "/find-a-program/",
  "/internships-abroad/",
  "/internships/",
  "/volunteer-abroad/",
  "/volunteer-abroad/projects/",
  "/teenage-volunteering/",
  "/a-levels/",
  "/career-breaks/",
  "/internships-abroad/core-internships/",
  "/family-volunteer-holidays/",
  "/gap-year/",
  "/language-immersion/",
  "/long-term-volunteering/",
  "/short-term-volunteering/",
  "/student-volunteering/",
  "/summer-internships-abroad/",
  "/summer-volunteer-programs/",
  "/combinations/",
  "/expeditions/",
  "/volunteer-holidays/",
  "/christmas-volunteering/",
  "/volunteering-for-teens/",
  "/resources/over-50s-volunteering/",
  "/internships-abroad/career-internships/",
  "/internships-abroad/research-internships/",
  "/conservation-issues/poverty/",
  "/volunteer-in-africa/",
  "/volunteer-in-asia/",
  "/volunteer-in-australasia/",
  "/volunteer-in-europe/",
  "/volunteer-in-latin-america/",
  "/volunteer-in-south-america/",
  "/volunteer-in-costa-rica/",
  "/volunteer-in-fiji/",
  "/volunteer-in-madagascar/",
  "/volunteer-in-mexico/",
  "/volunteer-in-peru/",
  "/volunteer-in-south-africa/",
  "/volunteer-in-thailand/",
  "/volunteer-in-canary-islands/",
  "/volunteer-in-canary-islands-spain/"
];

export const testingDomains = [
  "planet.gviworld.com",
  "people.gviworld.com",
  "localhost",
  "gtsb.io",
  "netlify.app",
  "gatsbyjs.io"
];

export const blockedCountries = ["eg", "tz"];

export const blockedCalendlyCountries = [
  "ae",
  "ar",
  "bs",
  "bh",
  "bb",
  "bg",
  "co",
  "cr",
  "cy",
  "cz",
  "do",
  "dz",
  "ec",
  "eg",
  "fj",
  "gh",
  "gr",
  "hu",
  "ht",
  "id",
  "il",
  "in",
  "ir",
  "iq",
  "ke",
  "kw",
  "la",
  "ma",
  "md",
  "ml",
  "mu",
  "mx",
  "na",
  "np",
  "ng",
  "pa",
  "pe",
  "pi",
  "pk",
  "pr",
  "py",
  "qa",
  "ri",
  "rh",
  "ro",
  "ru",
  "rp",
  "rw",
  "sa",
  "si",
  "sk",
  "th",
  "tn",
  "tr",
  "tt",
  "tz",
  "ua",
  "ug",
  "za",
  "zw"
];

export const allowedCalendlyCountries = [
  "gb",
  "us",
  "au",
  "ca",
  "nz",
  "ch",
  "no",
  "is",
  "al",
  "ad",
  "am",
  "at",
  "az",
  "by",
  "be",
  "ba",
  "bg",
  "hr",
  "cy",
  "cz",
  "dk",
  "ee",
  "fi",
  "fr",
  "ge",
  "de",
  "gr",
  "hu",
  "is",
  "ie",
  "xk",
  "lv",
  "li",
  "lt",
  "lu",
  "mk",
  "mt",
  "md",
  "mc",
  "me",
  "nl",
  "no",
  "pt",
  "ro",
  "ru",
  "sm",
  "rs",
  "sk",
  "si",
  "es",
  "se",
  "ch",
  "tr",
  "ua",
  "va",
  "gi",
  "fo",
  "im",
  "eu",
  "pl",
  "it"
];

export const blockedCalendlyConfig = {
  heading: "Schedule a call",
  title: "Let's talk",
  descText: "Alternatively, schedule a call time below via Calendly.",
  descAltText:
    "Schedule a call with one of our experts via Calendly by selecting a date and time below.",
  titleText:
    "Free to speak right now? Click the button below and we'll call you back immediately, or call us on ",
  gold: {
    eventID: "gvi-enrolment",
    eventLink: "gvi-program-introduction"
  },
  default: {
    eventID: "gvi-enrolment",
    eventLink: "gvi-program-introduction"
  }
};

export const blockedCountryValue = ["gvx-analytics-country"];

export const sf_scoring_config = {
  intro_terms: ["hello", "hey", "hi"],
  uni_terms: ["career"],
  program_terms: [
    "conservation",
    "marine",
    "wildlife",
    "climate",
    "environment",
    "education",
    "health",
    "human rights",
    "economic",
    "childcare",
    "research",
    "healthcare",
    "public health",
    "development",
    "community",
    "teaching",
    "empowerment",
    "construction",
    "environmental",
    "childhood",
    "early childhood"
  ],
  education_terms: [
    "bachelor",
    "degree",
    "university",
    "masters",
    "bachelors",
    "uni",
    "study"
  ],
  high_value_country: [
    "au",
    "ca",
    "de",
    "nl",
    "gb",
    "uk",
    "us",
    "ch",
    "fr",
    "dk"
  ],
  medium_value_country: ["ie", "es", "it", "mx"],
  low_value_country: ["za"],
  webtolead: {
    high: ["bushwise referral"],
    medium: [
      "gvi core aus application form",
      "gvi core can application form",
      "gvi core eur application form",
      "gvi core us application form",
      "gvi core uk application form",
      "gvi flex aus application form",
      "gvi flex can application form",
      "gvi flex eur application form",
      "gvi flex us application form",
      "gvi flex uk application form",
      "bushwise inquiry form",
      "bushwise intl online inquiry form",
      "bushwise online application form",
      "bushwise online inquiry form",
      "bushwise intl online application form",
      "friend/family referral",
      "live chat",
      "telephone enquiry",
      "gapforce",
      "interim"
    ],
    low: [
      "gvi core aus call back form",
      "gvi core can call back form",
      "gvi core eur call back form",
      "gvi core us call back form",
      "gvi core uk call back form",
      "bushwise campus open day form",
      "bushwise intl inquiry form",
      "bushwise contact form",
      "bushwise application form",
      "bushwise intl contact form",
      "bushwise online",
      "bushwise intl open day form",
      "bushwise live chat",
      "gvi flex aus call back form",
      "gvi flex can call back form",
      "gvi flex eur call back form",
      "gvi flex us call back form",
      "gvi flex uk call back form",
      "conservation careers",
      "gvi core aus inquiry form",
      "gvi core can inquiry form",
      "gvi core eur inquiry form",
      "gvi core us inquiry form",
      "gvi core uk inquiry form",
      "gvi flex aus inquiry form",
      "gvi flex can inquiry form",
      "gvi flex eur inquiry form",
      "gvi flex us inquiry form",
      "gvi flex uk inquiry form"
    ],
    negative: ["freiwilligenarbeit.de", "outreach"]
  }
};

export const gvi_online_programs = {
  sf_program_code: "GVIONLINE",
  sf_record_type: "0123k0000010iPlAAI",
  program_title: "GVI Online Program",
  online: {
    sf_program_code: "GVIONLINE",
    sf_record_type: "0123k0000010iPlAAI",
    program_title: "GVI Online Program"
  },
  virtual: {
    sf_program_code: "GVIVIRTUAL",
    sf_record_type: "0123k000000XRra",
    program_title: "GVI Virtual Internship"
  },
  virtual_uncc: {
    sf_program_code: "GVIVIRTUAL",
    sf_record_type: "0123k000000XRra",
    program_title: "Virtual Career Accelerator"
  },
  virtual_career: {
    sf_program_code: "GVICAREER",
    sf_record_type: "0123k000000XS2PAAW",
    program_title: "GVI Virtual Career Internship"
  },
  writing_academy: {
    sf_program_code: "GVWA0704U",
    sf_record_type: "0123k000000XS2KAAW",
    program_title: "GVI's Writing Academy"
  },
  gvi_flex: {
    sf_record_type: "012RO000000r9QA",
    program_title: "GVI Flex"
  },
  journeys: {
    sf_record_type: "012RO000004Im0fYAC",
    program_title: "Journeys"
  },
  program_cost: {
    en: {
      online: 645,
      online_abroad: 395,
      virtual: 895
    },
    us: {
      online: 795,
      online_abroad: 495,
      virtual: 1695
    },
    au: {
      online: 995,
      online_abroad: 695,
      virtual: 1695
    },
    za: {
      online: 11505,
      online_abroad: 6800,
      virtual: 15145
    },
    can: {
      online: 995,
      online_abroad: 695,
      virtual: 1695
    },
    ie: {
      online: 750,
      online_abroad: 460,
      virtual: 1145
    }
  }
};

export const gvi_open_days_config = {
  heading: "Hear from each of our bases",
  sub_heading:
    "Learn more about what life looks like at each of our locations, meet the teams on the ground and find out more about the programs on offer!"
};

export const whatsIncludedIngo = [];

export const whatsIncludedGVI = [];

export const ingo_global_support_fee = {
  gbp: 20,
  usd: 30,
  cad: 30,
  aud: 40,
  zar: 500,
  eur: 90
};

export const locationsMenu = [];

export const bwMahlahlaProgramsTerm = "zabf";

export const formDropdownPrimaryStyle = (errors) => {
  return {
    option: (provided) => ({
      ...provided,
      color: "white",
      background: "#A9A9A9",
      zIndex: 20
    }),
    control: (provided, state) => ({
      ...provided,
      background: "transparent",
      padding: "4px",
      borderColor:
        Object.values(errors).length && !state.hasValue
          ? "rgb(220 38 38)"
          : "rgb(231 231 242)"
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";
      const color = "white";
      const fontSize = "16px";
      const fontWeight = "bold";

      return { ...provided, opacity, transition, color, fontSize, fontWeight };
    },
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: "#ffffff"
      };
    },
    dropdownIndicator: (base) => ({
      ...base,
      color: "white",
      "&:hover": {
        color: "white"
      }
    }),
    indicatorSeparator: () => null
  };
};

export const formDropdownSecondaryStyle = (errors) => {
  return {
    option: (provided) => ({
      ...provided,
      color: "white",
      background: "#A9A9A9",
      zIndex: 20
    }),
    control: (provided, state) => ({
      ...provided,
      background: "transparent",
      padding: "4px",
      borderColor:
        Object.values(errors).length && !state.hasValue
          ? "rgb(220 38 38)"
          : "rgba(231, 231, 242, 0.3)",
      boxShadow: "none",
      "&:hover": {
        borderColor: "white"
      }
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";
      const color = "white";
      const fontSize = "16px";
      const fontWeight = "bold";

      return { ...provided, opacity, transition, color, fontSize, fontWeight };
    },
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: "#ffffff"
      };
    },
    dropdownIndicator: (base) => ({
      ...base,
      color: "white",
      "&:hover": {
        color: "white"
      }
    }),
    indicatorSeparator: () => null
  };
};

export const formFilterDropdownPrimaryStyle = (
  errors,
  extraOpts = { brand: "planet" }
) => {
  return {
    option: (provided) => ({
      ...provided,
      color: "white",
      background: extraOpts.brand === "planet" ? "#1B1B1B" : "#fff",
      zIndex: 20
    }),

    menuList: (provided) => ({
      ...provided,
      padding: 0
    }),
    container: (provided, state) => {
      return {
        ...provided,
        background: state?.hasValue ? "#E8EDEB" : "transparent"
      };
    },
    control: (provided, state) => {
      return {
        ...provided,
        background: "transparent",
        padding: "4px"
      };
    },
    singleValue: (provided, state) => {
      return {
        ...provided,
        opacity: state?.isDisabled ? 0.5 : 1,
        transition: "opacity 300ms",
        background: "transparent",
        color: "red"
      };
    },
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: "#ffffff"
      };
    },
    dropdownIndicator: (base) => ({
      ...base,
      color: "#4D5A62",
      "&:hover": {
        color: "white"
      }
    }),
    indicatorSeparator: () => null
  };
};

export const priceRangeFilters = {
  gbp: [
    { max: 750, label: "< 750" },
    { min: 750, max: 1500, label: "750 - 1500" },
    { min: 1500, max: 3000, label: "1500 - 3000" },
    { min: 3000, max: 5000, label: "3000 - 5000" },
    { min: 5000, max: 7000, label: "5000 - 7000" },
    { min: 7000, label: "> 7000" }
  ],
  eur: [
    { max: 750, label: "< 750" },
    { min: 750, max: 1500, label: "750 - 1500" },
    { min: 1500, max: 3000, label: "1500 - 3000" },
    { min: 3000, max: 5000, label: "3000 - 5000" },
    { min: 5000, max: 7000, label: "5000 - 7000" },
    { min: 7000, label: "> 7000" }
  ],
  usd: [
    { max: 1500, label: "< 1500" },
    { min: 1500, max: 3000, label: "1500 - 3000" },
    { min: 3000, max: 6000, label: "3000 - 6000" },
    { min: 6000, max: 10000, label: "6000 - 10000" },
    { min: 10000, max: 14000, label: "10000 - 14000" },
    { min: 14000, label: "> 14000" }
  ],
  cad: [
    { max: 1500, label: "< 1500" },
    { min: 1500, max: 3000, label: "1500 - 3000" },
    { min: 3000, max: 6000, label: "3000 - 6000" },
    { min: 6000, max: 10000, label: "6000 - 10000" },
    { min: 10000, max: 14000, label: "10000 - 14000" },
    { min: 14000, label: "> 14000" }
  ],
  aud: [
    { max: 1500, label: "< 1500" },
    { min: 1500, max: 3000, label: "1500 - 3000" },
    { min: 3000, max: 6000, label: "3000 - 6000" },
    { min: 6000, max: 10000, label: "6000 - 10000" },
    { min: 10000, max: 14000, label: "10000 - 14000" },
    { min: 14000, label: "> 14000" }
  ],
  zar: [
    { max: 15000, label: "< 15,000" },
    { min: 15000, max: 30000, label: "15,000 - 30,000" },
    { min: 30000, max: 60000, label: "30,000 - 60,000" },
    { min: 60000, max: 100000, label: "60,000 - 100,000" },
    { min: 100000, max: 140000, label: "100,000 - 140,000" },
    { min: 140000, label: "> 140,000" }
  ]
};

export const flexConfig = {
  showPricing: false
};

export const countryCodeList = {
  ad: "Andorra",
  ae: "United Arab Emirates",
  af: "Afghanistan",
  ag: "Antigua and Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  aq: "Antarctica",
  ar: "Argentina",
  as: "American Samoa",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Åland Islands",
  az: "Azerbaijan",
  ba: "Bosnia Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgium",
  bf: "Burkina",
  bg: "Bulgaria",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Bonaire, Sint Eustatius and Saba",
  br: "Brazil",
  bs: "Bahamas",
  bt: "Bhutan",
  bv: "Bouvet Island",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocos (Keeling) Islands",
  cd: "Congo, Democratic Republic of the",
  cf: "Central African Rep",
  cg: "Congo",
  ch: "Switzerland",
  ci: "Ivory Coast",
  ck: "Cook Islands",
  cl: "Chile",
  cm: "Cameroon",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cape Verde",
  cw: "Curaçao",
  cx: "Christmas Island",
  cy: "Cyprus",
  cz: "Czech Republic",
  de: "Germany",
  dj: "Djibouti",
  dk: "Denmark",
  dm: "Dominica",
  do: "Dominican Republic",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egypt",
  eh: "Western Sahara",
  er: "Eritrea",
  es: "Spain",
  et: "Ethiopia",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falkland Islands (Malvinas)",
  fm: "Micronesia",
  fo: "Faroe Islands",
  fr: "France",
  ga: "Gabon",
  gb: "United Kingdom",
  gd: "Grenada",
  ge: "Georgia",
  gf: "French Guiana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Greenland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Equatorial Guinea",
  gr: "Greece",
  gs: "South Georgia and the South Sandwich Islands",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hong Kong SAR China",
  hm: "Heard Island and McDonald Islands",
  hn: "Honduras",
  hr: "Croatia",
  ht: "Haiti",
  hu: "Hungary",
  id: "Indonesia",
  ie: "Republic of Ireland",
  il: "Israel",
  im: "Isle of Man",
  in: "India",
  io: "British Indian Ocean Territory",
  iq: "Iraq",
  ir: "Iran",
  is: "Iceland",
  it: "Italy",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kyrgyzstan",
  kh: "Cambodia",
  ki: "Kiribati",
  km: "Comoros",
  kn: "Saint Kitts & Nevis",
  kp: "Korea North",
  kr: "Korea South",
  kw: "Kuwait",
  ky: "Cayman Islands",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Lebanon",
  lc: "St Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lithuania",
  lu: "Luxembourg",
  lv: "Latvia",
  ly: "Libya",
  ma: "Morocco",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "Saint Martin (French part)",
  mg: "Madagascar",
  mh: "Marshall Islands",
  mk: "Macedonia",
  ml: "Mali",
  mm: "Myanmar",
  mn: "Mongolia",
  mo: "Macao",
  mp: "Northern Mariana Islands",
  mq: "Martinique",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "New Caledonia",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Netherlands",
  no: "Norway",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "French Polynesia",
  pg: "Papua New Guinea",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Poland",
  pm: "Saint Pierre and Miquelon",
  pn: "Pitcairn",
  pr: "Puerto Rico",
  ps: "Palestine, State of",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russian Federation",
  rw: "Rwanda",
  sa: "Saudi Arabia",
  sb: "Solomon Islands",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Sweden",
  sg: "Singapore",
  sh: "Saint Helena, Ascension and Tristan da Cunha",
  si: "Slovenia",
  sj: "Svalbard and Jan Mayen",
  sk: "Slovakia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "South Sudan",
  st: "Sao Tome & Principe",
  sv: "El Salvador",
  sx: "Sint Maarten (Dutch part)",
  sy: "Syria",
  sz: "Eswatini",
  tc: "Turks and Caicos Islands",
  td: "Chad",
  tf: "French Southern Territories",
  tg: "Togo",
  th: "Thailand",
  tj: "Tajikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turkey",
  tt: "Trinidad and Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  um: "United States Minor Outlying Islands",
  us: "United States",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Holy See",
  vc: "Saint Vincent & the Grenadines",
  ve: "Venezuela",
  vg: "Virgin Islands (British)",
  vi: "Virgin Islands (U.S.)",
  vn: "Viet Nam",
  vu: "Vanuatu",
  wf: "Wallis and Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "South Africa",
  zm: "Zambia",
  zw: "Zimbabwe"
};

export const defaultProgramTabsTitles = [
  { id: "overview", genTabTitle: "Overview", genTabOrder: 0 },
  { id: "dates_prices", genTabTitle: "Dates & Prices", genTabOrder: 1 },
  { id: "itinerary", genTabTitle: "Itinerary", genTabOrder: 2 },
  { id: "placements", genTabTitle: "Placements", genTabOrder: 3 },
  { id: "whats_included", genTabTitle: "What's Included", genTabOrder: 4 },
  { id: "life_on_base", genTabTitle: "Life on Base", genTabOrder: 5 },
  { id: "experiences", genTabTitle: "Experiences", genTabOrder: 6 },
  {
    id: "free_time",
    genTabTitle: "Free time & cultural immersion",
    genTabOrder: 7
  },
  { id: "reviews", genTabTitle: "Reviews", genTabOrder: 8 },
  { id: "speak_to_alumni", genTabTitle: "Speak to alumni", genTabOrder: 9 },
  { id: "meet_the_team", genTabTitle: "Meet the team", genTabOrder: 10 },
  { id: "parent_info", genTabTitle: "Parent Info", genTabOrder: 11 },
  { id: "arrivals", genTabTitle: " Arrivals & <br/> Flights", genTabOrder: 12 },
  { id: "your_impact", genTabTitle: "Your Impact", genTabOrder: 13 },
  { id: "publications", genTabTitle: "Publications", genTabOrder: 14 },
  { id: "our_ethics", genTabTitle: "Our Ethics", genTabOrder: 15 },
  { id: "program_ethics", genTabTitle: "Program Ethics", genTabOrder: 16 },
  { id: "career", genTabTitle: "Careers", genTabOrder: 17 },
  {
    id: "qualification_training",
    genTabTitle: "Qualifications & Training Options",
    genTabOrder: 18
  },
  { id: "support", genTabTitle: "Support & Safety", genTabOrder: 19 }
];

export const step2_exclusion_list = [
  "itinerary",
  "outreach",
  "virtual",
  "callback",
  "online",
  "consultation",
  "download"
];